import { Controller } from "@hotwired/stimulus"
import loadLiff from "../src/authen/load_liff.js"

export default class ExpiredLiffApp extends Controller {
  async closeLiffApp() {
    const liff = await loadLiff()
    liff.closeWindow()
  }
}
